<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    width="500"
  >
    <template v-slot:activator="{ on, attrs }">
      <button v-bind="attrs" v-on="on" tabindex="0" class="settings-button">
        {{ translations.home.labels.settings }}
      </button>
    </template>

    <v-card class="settings">
      <v-toolbar color="blue" class="settings__toolbar">
        <v-btn icon @click="dialog = false">
          <v-icon color="black">mdi-close</v-icon>
          <span class="sr-only">{{ translations.settings.text.close }}</span>
        </v-btn>

        <v-toolbar-title class="settings__title">{{
          translations.settings.title
        }}</v-toolbar-title>
      </v-toolbar>

      <v-container>
        <v-row>
          <v-col cols="12">
            <label class="settings__label" for="fonts" id="languageSelect">
              {{ translations.settings.text.changedefault }}
            </label>

            <v-switch
              v-model="openDyslexic"
              name="fonts"
              class="d-block w-100"
              width="100%"
              :label="`OpenDyslexic`"
              @change="fontChangeHandler(openDyslexic)"
              solo
              hide-details
            ></v-switch>
          </v-col>
        </v-row>

        <!-- <v-row>
          <v-col cols="12">
            <fieldset class="settings__checkbox-fieldset">
              <legend class="settings__checkbox-legend">
                {{ translations.welcome.user_type_heading }}
              </legend>

              <div class="settings__checkbox-container">
                <v-checkbox
                  v-model="selectedUserType"
                  value="Professional"
                  name="user_type"
                  color="primary"
                  :label="translations.welcome.professional_label"
                  hide-details
                ></v-checkbox>

                <v-checkbox
                  v-model="selectedUserType"
                  value="Care Leaver"
                  name="user_type"
                  color="primary"
                  :label="translations.welcome.care_leaver_label"
                  hide-details
                ></v-checkbox>
              </div>
            </fieldset>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col cols="12">
            <label for="langs" class="settings__label">
              {{ translations.settings.text.languages }}
            </label>

            <v-select
              :items="langs"
              item-text="name"
              item-value="code"
              v-model="selectedLang"
              solo
              flat
              hide-details
              background-color="blue"
              item-color="black"
              append-icon="mdi-chevron-down"
              color="black"
              id="langs"
              @change="languageSelectHandler(selectedLang)"
            />
          </v-col>
        </v-row>

        <!-- <v-row>
          <v-col cols="12">
            <label class="settings__label" for="user-location">
              {{ translations.welcome.location_heading }}
            </label>

            <v-select
              :items="locations"
              :hint="locationsHint"
              v-model="selectedUserLocation"
              solo
              hide-details="auto"
              persistent-hint
              id="user-location"
              name="user-location"
            ></v-select>
          </v-col>
        </v-row> -->

        <v-alert
          close-text="Close Alert"
          color="pink"
          rounded="false"
          dismissible
          icon="mdi-alert-circle"
          icon-color="black"
          class="banner settings_page-alerts mt-6 black--text"
          light
          @input="DismissFontAlert()"
          v-if="fontAlert"
        >
          <span v-if="openDyslexic">
            {{ translations.settings.text.textopen }}
          </span>
          <span v-else>{{ translations.settings.text.textdefault }}</span>
        </v-alert>

        <v-alert
          close-text="Close Alert"
          color="pink"
          rounded="false"
          dismissible
          icon="mdi-alert-circle"
          class="banner settings_page-alerts mt-6 black--text"
          light
          @input="DismissAlert()"
          v-if="alert"
        >
          {{ translations.settings.text.languageset }} {{ currentLang }}
        </v-alert>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Settings",
  data: () => ({
    drawer: false,
    selectedLang: localStorage.getItem("current_lang"),
    dialog: false,
    fontAlert: false,
    alert: false,
    openDyslexic: false,
  }),
  mounted() {
    if (localStorage.getItem("enable_font_change") === "true") {
      this.openDyslexic = true;
    } else {
      this.openDyslexic = false;
    }

    /// listening for language change emit coming form Header.vue
    /// we're passing the 'language' and then setting is as a selected one
    this.$bus.$on("language-changed-from-header", (language) => {
      this.selectedLang = language;
    });
  },
  beforeDestroy() {
    // stop listening for the emit coming from Header.vue
    this.$bus.$off("language-changed-from-header");
  },
  methods: {
    ...mapActions("hubbdata", [
      "updateLang",
      "updateFont",
      "saveUserType",
      "saveUserLocation",
    ]),
    languageSelectHandler(selectedLang) {
      this.updateLang(selectedLang);

      this.alert = true;
      // send a global emit back to Header.vue with the newly selected language
      this.$bus.emit("language-changed-from-settings-page", this.selectedLang);
    },
    fontChangeHandler(font) {
      localStorage.setItem("enable_font_change", font);
      // console.log(font);
      this.updateFont(font);
      this.fontAlert = true;
    },
    DismissAlert() {
      this.alert = false;
    },
    DismissFontAlert() {
      this.fontAlert = false;
    },
    sendGoogleAnalyticsEvent() {
      /* eslint-disable */
      gtag("event", "user_type", {
        value: this.selectedUserType,
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapGetters("hubbdata", ["translations"]),
    ...mapGetters("hubbdata", {
      translations: "translations",
      langs: "getLanguages",
      locations: "getLocations",
    }),
    currentLang() {
      return this.langs.find((lang) => lang.code === this.selectedLang);
    },
    locationsHint() {
      if (this.selectedLocation && this.selectedLocation === "All Locations") {
        return this.translations.welcome.all_locations_hint;
      } else if (this.selectedLocation) {
        let hintText = this.translations.welcome.other_locations_hint.replace(
          "[location]",
          this.selectedLocation
        );
        return hintText;
      }

      return "";
    },
    selectedUserLocation: {
      get: function () {
        return this.$store.getters["hubbdata/getUserLocation"];
      },
      set: function (newValue) {
        this.saveUserLocation(newValue);

        this.updateOneSignalLocation(newValue);
      },
    },
    selectedUserType: {
      get: function () {
        return this.$store.getters["hubbdata/getUserType"];
      },
      set: function (newValue) {
        this.saveUserType(newValue);

        this.sendGoogleAnalyticsEvent();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-button {
  display: block;
  width: 100%;
  padding: 8px;
  min-height: 40px;
  text-align: left;
  border-radius: 0;
  font-size: 1rem !important;
  font-weight: 600 !important;
  line-height: 1.3 !important;
  color: $black !important;

  &:focus {
    outline: 2px solid $black !important;
  }
}

.settings {

  &__toolbar {
    height: auto !important;
    padding-top: var(--sat);
  }

  &__label {
    display: block;
    width: 100%;
    font-size: 1rem;
    font-weight: 900;
    line-height: 1.3;
    word-break: break-word;
  }

  &__checkbox-fieldset {
    border: 0;
    margin: 0;
    padding: 0;
  }

  &__checkbox-legend {
    font-size: 1rem;
    font-weight: 900;
  }

  &__checkbox-container {
    display: flex;
    column-gap: 30px;

    @media (max-width: 700px) {
      flex-direction: column;
    }
  }

  &__title {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.3;
    color: $black !important;
    word-break: break-word;
  }

  ::v-deep {
    .v-select {
      margin-top: 13px !important;
      border: 1px solid $black !important;
      border-radius: 0;

      .v-input__control {
        min-height: 35px;
      }

      &.v-input--is-focused {
        outline: 2px solid $black;
        outline-offset: 2px;
      }

      .v-label {
        color: $black !important;
      }

      .v-select__selection {
        font-size: 1rem !important;
        font-weight: 600;
        color: $black !important;
      }

      .v-icon {
        color: $black !important;
      }

      input {
        color: $black !important;
      }
    }

    .v-alert {
      font-weight: 700;

      .v-icon {
        color: $black !important;
      }
    }
  }
}
</style>
